import { render, staticRenderFns } from "./OutStockKanbanTV.vue?vue&type=template&id=9bf90706&"
import script from "./OutStockKanbanTV.vue?vue&type=script&lang=js&"
export * from "./OutStockKanbanTV.vue?vue&type=script&lang=js&"
import style0 from "./OutStockKanbanTV.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports